/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";

/**
 * The TransformerOilLeak component
 *
 * @author Thais Watanabe
 */
const TransformerOilLeak = (props) => {
  const {
    turbineInspection,
    title,
    inspectionModel,
    result,
    openEdit,
    openObs,
    isPastInspection,
    inspection,
    lastTurbineInspections,
  } = props;

  return (
    <div className="flex flex-col gap-y-5">
      <Table>
        <thead>
          <tr>
            <ColHeader
              id={inspectionModel?.name}
              className="w-10 text-center print:hidden"
              rowSpan={2}
            >
              {!isPastInspection && (
                <ResultDropdown
                  openEdit={openEdit}
                  openObs={openObs}
                  selectedItem={inspectionModel}
                  turbineInspection={turbineInspection}
                  selectedResult={result}
                  lastTurbineInspections={lastTurbineInspections}
                  inspection={inspection}
                />
              )}
            </ColHeader>
            <ColHeader className="text-center" colSpan={3}>
              {title}
            </ColHeader>
          </tr>
          <tr>
            <ColHeader className="text-center">フィン区分</ColHeader>
            <ColHeader className="text-center">漏れフィン番号</ColHeader>
            <ColHeader className="text-center">漏れ箇所数</ColHeader>
          </tr>
        </thead>
        <TableBody>
          {result?.childrenResults?.length > 0 ? (
            result?.childrenResults?.map((childResult, i) => (
              <tr key={i} className="text-center">
                <Col className=" print:hidden"></Col>
                <Col>{childResult.split(",")[0]}</Col>
                <Col>{childResult.split(",")[1]}</Col>
                <Col>
                  {[...Array(i)]
                    .map((_, y) => y)
                    .filter(
                      (obj) => childResult === result.childrenResults[obj]
                    ).length + 1}
                </Col>
              </tr>
            ))
          ) : (
            <tr className="text-center">
              <Col colSpan={4}>なし</Col>
            </tr>
          )}
        </TableBody>
      </Table>
    </div>
  );
};

export default TransformerOilLeak;
